import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './SuccessPage.scss';
import SuccessIcon from './Images/success.svg';
import SelectedSong from '../../Components/SelectedSong/SelectedSong';
import FuntoneButton from '../../Components/FuntoneButton/FuntoneButton';
import { useScreenNavigation } from '../../Utils/ScreenNavigationUtils';
import { setIsChangePackageFlow, saveToHistory, setIsAddServiceFlow } from '../../FuntoneSlice';
import PackageCard from '../../Components/PackageCard/PackageCard';

const SuccessPage = (props) => {
  const { selectedSong, selectedPackage, selectedSubscriber, isChangePackageFlow, isAddServiceFlow } = props.funtoneSlice;
  const dispatch = useDispatch();
  const { navigateToAdminPanel, navigateToSongSettings, navigateToCatalog } = useScreenNavigation();
  const title = (isAddServiceFlow || selectedSubscriber?.isFirstSong) ? `יש לך MusiCall` : isChangePackageFlow ? 'החבילה שלך שונתה בהצלחה' : `יש לך שיר חדש`;
  const selectedSongTitle = selectedPackage || selectedSubscriber?.hasService ? 'השיר שבחרת' : 'השיר שלך';
  console.log(isChangePackageFlow);
  console.log(selectedPackage);

  // Save to history on mount
  useEffect(() => {
    dispatch(saveToHistory('success'));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      if (isChangePackageFlow || isAddServiceFlow) {
        dispatch(setIsChangePackageFlow(false));
        dispatch(setIsAddServiceFlow(false));
      }
    };
  }, []);
  
  const handleGoToAdminPanel = () => {
    navigateToAdminPanel({
      onAfterNavigate: () => dispatch(setIsChangePackageFlow(false)),
    });
  };

  const handleGoToSongSettings = () => {
    navigateToSongSettings({
      onAfterNavigate: () => dispatch(setIsChangePackageFlow(false)),
    });
  };

  return (
    <div className={'funtone-success-page'}>
      <div className='top-content'>
        <Image className={'success-icon'} src={SuccessIcon} alt={'Success'} />
        <span className='success-title'>{title}</span>
      </div>

      {isChangePackageFlow && selectedPackage ? (
        <PackageCard packageItem={selectedPackage} isChangePackageFlow={isChangePackageFlow} selectedPackage={selectedPackage} />
      ) : (
        <SelectedSong title={selectedSongTitle} song={selectedSong} selectedPackage={selectedPackage} />
      )}
      {!isChangePackageFlow && !selectedSubscriber?.isFirstSong && (
        <div className='select-contact'>
          <span className='select-contact-text'>רוצה לבחור מי ישמע את השיר?</span>
          <FuntoneButton text='כן, בואו נמשיך' variant='secondary' onClick={handleGoToSongSettings} />
        </div>
      )}
      <div className='bottom-container'>
        <FuntoneButton
          text={isChangePackageFlow ? 'סיום' : 'להורדת שיר נוסף'}
          variant='primary'
          onClick={isChangePackageFlow ? handleGoToAdminPanel : navigateToCatalog}
        />
        {!isChangePackageFlow && (
          <button className='songs-lobby-button' onClick={handleGoToAdminPanel}>
            לאזור ניהול השירים
          </button>
        )}
      </div>
    </div>
  );
};

export default SuccessPage;
